import { AxiosError, AxiosResponse } from "axios";
import SkTechApiClient from "./base/SkTechApiClient";
import dayjs, { Dayjs } from 'dayjs';

export type CalendarEvent = {
        companyUserId: number
        projectId: number
}

export default class FavoriteProjectApiClient extends SkTechApiClient {

    public getFavoriteProjectIds = async (userId: number): Promise<number[]> => {
        return await this.Get(`/api/FavoriteProject/GetFavoriteProjectIds/${userId}`)
            .then((response) => {
                if (response.status === 200) {
                    return response.data
                }
                return [];
            })
            .catch(function (error) {
                console.log(error);
                return [];
            });
    }

      public addFavoriteProject = async (value: CalendarEvent) => {
        return await this.Post(`/api/FavoriteProject/AddFavoiteProject`, value)
          .then((response) => {
            if (response.status === 200) {
              return true;
            }
            return false;
          })
          .catch(function (error) {
            console.log(error);
            return false;
          });
      }

    public deleteFavoriteProject = async (value: CalendarEvent) => {
        return await this.Delete(`/api/FavoriteProject/RemoveFavoriteProject`, value)
            .then((response) => {
                if (response.status === 200) {
                    return true;
                }
                return false;
            })
            .catch(function (error) {
                console.log(error);
                return false;
            });
    }
}
